// @flow
import React from 'react';
import { useI18n, withI18n } from '@shopify/react-i18n';

import { Badge, Icon, Link, Button } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import history from 'src/routes/history';
import { routes } from 'src/routes';

type IProps = {
  index: number,
  data: IntegrationData
};

type IntegrationData = {
  icon: string,
  name: string,
  appName?: string,
  appType?: string,
  integration?: string,
  appListingURL: string,
  description: string,
  instructionURL: string,
  iconStyle?: React.CSSProperties,
  tags?: string[]
};

const OtherCard: React.FC<IProps> = ({ index, data }) => {
  const [i18n] = useI18n();

  const {
    icon,
    name,
    appName,
    appListingURL,
    description,
    instructionURL,
    iconStyle,
    tags
  } = data || {};

  const handleConfigure = () => {
    console.log("appName", appName, routes.integration)
    if (appName) {
      history.push(routes.integration?.[appName]?.view());
    }
  };

  return (
    <div className={index === 1 ? 'item middle' : 'item'} key={`item-${index}`}>
      <div className="item-header">
        <a className="Polaris-Link" href={appListingURL} target="_blank" rel="noopener noreferrer">
          <img
            className="icon"
            src={icon}
            alt={i18n.translate(name)}
            style={iconStyle ? iconStyle : {}}
          />
        </a>
        <div className="BC-Integration-Tag__Wrapper">
          {tags?.map((tag, index) => (
            <div className="integration">
              <Badge key={index}>
                {i18n.translate(tag)}
              </Badge>
            </div>
          ))}
        </div>
      </div>
      {/* App name */}
      <div className="name">{i18n.translate(name)}</div>

      {/* App description */}
      <div className="description">{i18n.translate(description)}</div>

      <div className="BC-Checkbox-Status__Wrapper">
        <div className="integration">
          <Badge status="info">
            <Link url={instructionURL} external>
              {i18n.translate('AdminHTML.Integration.Constants.integrationGuide')}
              <Icon source={ExternalMinor} />
            </Link>
          </Badge>
        </div>

        <div className="btn-configure">
          <Button onClick={handleConfigure}>
            {i18n.translate('AdminHTML.Integration.Integration.configure')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(OtherCard);
